import { render, staticRenderFns } from "./businessLicenses.vue?vue&type=template&id=b2957d64&scoped=true"
import script from "./businessLicenses.vue?vue&type=script&lang=js"
export * from "./businessLicenses.vue?vue&type=script&lang=js"
import style0 from "./businessLicenses.vue?vue&type=style&index=0&id=b2957d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2957d64",
  null
  
)

export default component.exports